import { Option } from 'owa-options-core';
import * as React from 'react';
import { isFeatureEnabled } from 'owa-feature-flags';
import ActionConfirmationsOptionFull from './components/ActionConfirmationsOptionFull';
import { discardActionConfirmationsOption } from './actions/internalActions';
import isActionConfirmationsOptionDirty from './selectors/isActionConfirmationsOptionDirty';
import saveActionConfirmationsOption from './orchestration/saveActionConfirmationsOption';

let ActionConfirmationsOption: Option = {
    key: 'actionNotifications',
    titleStringKey: 'optionTitle_actionConfirmations',
    searchTermsStringKey: 'optionTitle_actionConfirmations',
    isHidden: () => !isFeatureEnabled('tri-notificationBar'),
    fullOptionFormSettings: {
        render: () => <ActionConfirmationsOptionFull />,
        isDirty: isActionConfirmationsOptionDirty,
        onSave: saveActionConfirmationsOption,
        onDiscard: discardActionConfirmationsOption,
    },
};
export default ActionConfirmationsOption;
